import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
//UI
import axios from 'axios';
import { Input } from "../../../../../ui/inputs/Input";

const headCells = [
  {
    id: "activoPagos",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Activo Pagos",
    textAlign: "center",
  },
  {
    id: "activo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Activo General",
    textAlign: "center",
  },
  {
    id: "codconcep",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nomconcep",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
];

export default function TablaConceptosPagos(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  // Obtenemos los componentes y funciones del hook useTable
  const tableReturn = useTable(records, headCells, filterFn);
  
  // Normalmente useTable devuelve un objeto con estas propiedades
  const TblContainer = tableReturn.TblContainer || tableReturn.TableContainer;
  const TblHead = tableReturn.TblHead || tableReturn.TableHead;
  const recordsAfterPagingAndSorting = tableReturn.recordsAfterPagingAndSorting || tableReturn.filteredRecords;

  // Función de filtrado que busca en todos los campos de la tabla
  const applyFilter = (searchValue) => {
    if (!searchValue.trim()) {
      setFilterFn({
        fn: (items) => items
      });
      return;
    }

    const searchLower = searchValue.toLowerCase().trim();
    setFilterFn({
      fn: (items) => {
        return items.filter(item => 
          // Buscar en código de concepto
          (item.codconcep?.toLowerCase() || '').includes(searchLower) ||
          // Buscar en nombre
          (item.nomconcep?.toLowerCase() || '').includes(searchLower)
        );
      }
    });
  };

  // Manejador del cambio en el input de búsqueda
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    applyFilter(value);
  };

  const seleccionarConceptos = (codIntegrante) => {
    if (!codIntegrante) return;
    
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let id = codIntegrante;
    let condi = ' t4.status = 1  ';

    let endpoint = `${op.conexion}/api/nomina/seleccionarconceptosinte2condi?esquema=${esquema}&id=${id}&condi=${condi}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          console.log(response.data);
          setRecords(response.data);
          // Resetear búsqueda cuando cambia el integrante
          setSearchTerm("");
          setFilterFn({ fn: (items) => items });
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || 'Error al cargar el registro',
          icono: 'error'
        });
      })
      .finally(() => setActivate(false));
  };

  useEffect(() => {
    seleccionarConceptos(props.codIntegrante);
  }, [props.codIntegrante]);

  // Si no se pudieron obtener los componentes, mostrar un mensaje de carga o error
  if (!TblContainer || !TblHead) {
    return <div>Cargando componentes de tabla...</div>;
  }

  return (
    <div className="col-12 m-0 p-0 d-flex flex-wrap">
      <div className="col-12 m-0 mb-2 p-0">
        <Input 
          placeholder="Buscar por código o nombre del concepto..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>
      
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records && recordsAfterPagingAndSorting().map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>
                  <input 
                    type="checkbox" 
                    checked={item.activopagos || false}
                    disabled={true}
                  />
                </td>
                <td style={{ textAlign: "center" }}>
                  <input 
                    type="checkbox" 
                    checked={item.activo || false}
                    disabled={true}
                  />
                </td>
                <td style={{ textAlign: "center" }}>{item.codconcep}</td>
                <td style={{ textAlign: "left" }}>{item.nomconcep}</td>
              </tr>
            ))}
          </tbody>
        </TblContainer>
      </div>
    </div>
  );
}